import template from './anonymous_survey.html';
import * as Utils from '../../../lib/savanna_utils.js';
import tr from '../../../lib/default-translator.js';

class AnonymousSurveysViewModel
{
	constructor (page)
	{
		this.page = page;
		this.survey = ko.observableArray();
		this.survey_id = ko.observable();
		this.employee_id = ko.observable();
		this.segment_id = ko.observable();
		this.radio_box = ko.observable(false);
		this.expired = ko.observable(false);
		this.survey_title = ko.observable();
	}

	async submit(v, e)
	{
		await this.page.send_survey_data_to_server(this.page.extract_survey_data(v.survey_questions));
		await Grape.alerts.alert({ type: 'success', message: 'Thank you for your time!' });
		window.current_page_title('');
		Grape.navigate('/ui/login');
	}
}

class AnonymousSurveysPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AnonymousSurveysViewModel(this);
		this.viewModel.employee_id(Utils.get_local_storage_nullable('employee_id'));

		if (this.viewModel.employee_id() == null || this.viewModel.employee_id() == 0)
			this.viewModel.employee_id(0);

		this.viewModel.segment_id(bindings.segment);
		this.viewModel.survey_id(bindings.id);
		this.updateData();
	}

	init()
	{
		// update the page title
		document.title = tr('Complete Anonymous Survey');
		window.current_page_title(tr('Complete Anonymous Survey'));
	}

	updateData()
	{
		if (this.bindings.id == undefined)
			return;

		this.load_survey();
	}

	extract_generic_survey_data(question_params)
	{
		return {
			question_response: question_params.response,
			time_completed: question_params.time_completed
		};
	}

	// --------------
	// FUNCTION: Extract checkbox data
	extract_survey_checkbox_data(question_params)
	{
		let chkBoxResponse = '';
		_.each(question_params.options_list, (obj) => {
			if (obj.option_checked == true)
				chkBoxResponse += obj.option_text + ', ';
		});
		return {
			question_response: chkBoxResponse
		};
	}

	// --------------
	// FUNCTION: Extract radiobox data
	extract_survey_radiobox_data(question_params)
	{
		let rdbBoxResponse = '';
		_.each(question_params.options_list, (obj) => {
			if (typeof obj.option_checked !== 'boolean')
				rdbBoxResponse = obj.option_text;
		});
		return {
			question_response: rdbBoxResponse
		};
	}

	// --------------
	// FUNCTION: Set response structure with id and time completed
	set_response(question)
	{
		return {
			question_id: question.question_id,
			question_response: ''
		};
	}

	extract_survey_data(survey)
	{
		let survey_result = [];

		_.each(survey, (question) => {
			let response = this.set_response(question);

			switch (question.question_type)
			{
				case 'survey_radiobox':
					Object.assign(response, this.extract_survey_radiobox_data(question.question_params));
					this.viewModel.radio_box(true);
					break;
				case 'survey_checkbox':
					Object.assign(response, this.extract_survey_checkbox_data(question.question_params));
					break;
				case 'survey_range':
					Object.assign(response, this.extract_generic_survey_data(question.question_params));
					break;
				case 'survey_textarea':
					Object.assign(response, this.extract_generic_survey_data(question.question_params));
					break;
				case 'survey_input':
					Object.assign(response, this.extract_generic_survey_data(question.question_params));
					break;
			}

			survey_result.push(response);
		});

		return survey_result;
	}

	// LOGIC: Send survey data to server
	async send_survey_data_to_server(server_data)
	{
		_.forEach(server_data, async (item) => {
			if (item.question_response != '')
			{
				let res = await Grape.fetches.postJSON('/surveys/anonymous_surveys/save_anonymous_answers', {
					survey_id: this.viewModel.survey_id(),
					survey_items_id: item.question_id,
					answer: item.question_response,
					segment_id: this.viewModel.segment_id()
				});
			}
		});
	};

	async load_survey()
	{
		let res_surveys = await Grape.fetches.getJSON('/surveys/anonymous_surveys', {
			survey_id: this.viewModel.survey_id()
		});

		if (res_surveys.length > 0 && res_surveys[0].survey_questions) {
			res_surveys[0].survey_questions.sort((a, b) => a.question_id - b.question_id);
		}

		/*let res_surveys = await Grape.fetches.getJSON('/api/record', {
			table: 'v_surveys',
			schema: 'savanna',
			limit: 5000,
			filter: [
				{ value: ['Sent', 'Read', 'Done'], operand: 'IN', field: 'survey_status' },
				{ value: this.bindings.id, operand: '=', field: 'survey_id' }
			]
		});*/

		if (res_surveys.status !== 'ERROR')
		{
			if (res_surveys && res_surveys.length > 0)
			{
				let survey_data = res_surveys[0];
				this.viewModel.survey_title(survey_data.title);

				if (survey_data.end_date)
				{
					let end_date = new Date(survey_data.end_date);
					let now = new Date();

					if (end_date < now)
						this.viewModel.expired(true);
					else
						this.viewModel.expired(false);
				}

				_.each(res_surveys[0].survey_questions, (items) => {
					items.question_params =
					{
						question_description: items.question_params[0].question_description || '',
						options_list: items.question_params[0].options_list || '',
						response: items.question_params[0].response || '',
						min_value: items.question_params[0].min_value || 0,
						max_value: items.question_params[0].max_value || 0,
						default_min_value: items.question_params[0].default_min_value || 0,
						default_max_value: items.question_params[0].default_max_value || '',
						step: items.question_params[0].step || 1,
						dual: items.question_params[0].dual || false,
						time_completed: '',
						checkbox_response: [],
						radiobutton_response: '',
						radiobox_name: 'radiobox_' + Math.random().toString(36).substring(7),
						slider_range_id: 'range_' + Math.random().toString(36).substring(7),
						checkbox_name: 'checkbox_' + Math.random().toString(36).substring(7)
					};
				});
				this.viewModel.survey(res_surveys[0]);
			}
		}
		else
			this.viewModel.survey(null);
	}
}

export default {
	route: `/surveys/anonymous_survey/:id/:segment`,
	page_class: AnonymousSurveysPage,
	template: template,
	template_filename: 'translation/anonymous_surveys'
};
